import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"row mb-6 mt-6\" style=\"padding-left:30px;\"><h3 class=\"fw-bolder m-0\"><span class=\"card-label fw-bolder fs-3 mb-1\">Tabel Dokumen</span></h3><h3 class=\"fw-bolder m-0\"><span class=\"text-muted mt-1 fw-bold fs-7\">Tabel Dokumen Sekolah </span></h3></div>", 1)
const _hoisted_4 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tipe"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal Upload PKS"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Batas Akhir PKS"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Verifikasi")
  ])
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  class: "text-left",
  style: {"padding-left":"15px"}
}
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _hoisted_8,
              (_ctx.items.lengtable != 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.tableData, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_10, _toDisplayString(item.typ), 1),
                        _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.dateTime(item.createTime)), 1),
                        _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.dateTime(item.expiredDate)), 1),
                        _createElementVNode("td", _hoisted_13, _toDisplayString(item.status), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_14, _hoisted_16))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}